import '../App.css';

function ProjectButton({name, icon, link}) {
    return (
        <div className='Project-Button'>
            <button onClick={
                () => {
                    window.open(link, '_blank')
                }
            }>{name}{icon}</button>

        </div>
    )
}

export default ProjectButton;